import {Component, Input, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {DadService} from '../../../services/dad.service';
import {formatDate} from '@angular/common';
import {saveAs} from 'file-saver';
import {UtilsService} from '../../../../appSharedModule/services/utils.service';

@Component({
  selector: 'app-comparison-report',
  templateUrl: './comparison-report.component.html',
  styleUrls: ['./comparison-report.component.scss']
})
export class ComparisonReportComponent implements OnInit {

  @Input() set exchangeNamesList(value) {
    this.selectedExchanges = [];
    this.uniqExchangeItems = [];
    value.forEach(exchangeItem => {
      if (this.uniqExchangeItems.filter(item => item.value === exchangeItem.value).length === 0) {
        this.uniqExchangeItems.push(exchangeItem);
        this.selectedExchanges.push(exchangeItem.value);
      }
    });
  }

  @Input() set companiesItems(value) {
    this.selectedClients = [];
    this.uniqCompanyItems = [];
    value.forEach(companyItem => {
      if (this.uniqCompanyItems.filter(item => item.value === companyItem.value).length === 0) {
        this.uniqCompanyItems.push(companyItem);
        this.selectedClients.push(companyItem.value);
      }
    });
  }

  selectedClients: SelectItem[] = [];
  dateFilterFrom: any;
  dateFilterTo: any;
  selectedExchanges = [];
  uniqCompanyItems = [];
  uniqExchangeItems = [];

  constructor(private dadService: DadService, private utilsService: UtilsService) {
  }

  ngOnInit() {
    this.initializeDateFilter();
  }

  private initializeDateFilter() {
    this.dateFilterFrom = new Date();
    this.dateFilterFrom.setDate(1);
    this.dateFilterFrom.setMonth(this.dateFilterFrom.getMonth() - 2);
    this.dateFilterTo = new Date();
    this.dateFilterTo.setMonth(this.dateFilterTo.getMonth() - 1);
    this.dateFilterTo.setDate(1);
  }

  exportReport() {
    this.utilsService.lockUi();
    this.dadService.getComparisonReport(
      this.selectedExchanges,
      this.dateFilterFrom,
      this.dateFilterTo,
      this.selectedClients
    ).subscribe({
        next: res => {
          const fileNamePrefix = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
          let fileNameSuffix = '';
          if (this.selectedExchanges.length === 1) {
            fileNameSuffix += '_Comparison_Report_' + this.selectedExchanges[0] + '.xlsx';
          } else {
            fileNameSuffix += '_Comparison_Report.xlsx';
          }
          this.downLoadFile(res, fileNamePrefix + fileNameSuffix);
          this.utilsService.unlockUi();
        }, error: () => {
          this.utilsService.unlockUi();
          this.utilsService.displayMessage('The comparison report could not be exported', 'Please try again later.', 'error');
        }
      }
    );
  }

  downLoadFile(data: any, fileName: string) {
    const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    saveAs(blob, fileName);
  }
}
